import { createLogic } from 'redux-logic'
import { map } from 'rxjs/operators'
import * as constants from '../constants'

export const getCities = createLogic({
    type: constants.GET_CITIES.ACTION,
    processOptions: {
        successType: constants.GET_CITIES.FULFILLED,
        failType: constants.GET_CITIES.REJECTED
    },
    process({ http, action }) {

        return http
            .post('/comps/city', action.payload)
            .pipe(
                map(http.getBody)
            )
    }
})
